export default "__VITE_ASSET__C$qUkT15__"